import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import moment from 'moment';

@Component({
  selector: 'app-apply-to-all',
  templateUrl: './apply-to-all.component.html',
  styleUrls: ['./apply-to-all.component.scss'],
  animations: [
    trigger('applyToAllEnterAnimation', [
      transition(':enter', [style({ opacity: 0, height: 0, margin: '0 auto' }), animate('100ms', style({ opacity: 1, height: '50px' }))]),
      transition(':leave', [
        style({ opacity: 1, margin: '10px auto' }),
        animate('100ms', style({ opacity: 0, height: 0, margin: '0 auto' })),
      ]),
    ]),
  ],
})
export class ApplyToAllComponent implements OnInit {
  @Input() dataSource: MatTableDataSource<any>;
  @Output() appliedToAll: EventEmitter<MatTableDataSource<any>> = new EventEmitter();

  public fieldTitle: string;
  public displayValue: any;
  public showPrompt: boolean;
  public applyToAllValue: any;
  public propName: string;

  public isMouseOverPrompt: boolean;

  constructor(private datePipe: DatePipe) {}

  ngOnInit(): void {}

  public generateApplyToAllPrompt(fieldTitle: string, applyToAllValue: any, propName: string, displayPropName?: string) {
    // Only a single item don't need to bother with apply to all!
    if (this.dataSource.data.length <= 1) {
      return;
    }

    this.applyToAllValue = applyToAllValue;
    this.fieldTitle = fieldTitle;
    this.propName = propName;

    const newValue = applyToAllValue;
    if (typeof newValue !== 'object' && moment.utc(newValue, null, true).isValid()) {
      this.displayValue = moment.utc(newValue).format("MMM-yyyy");
    } else {
      this.displayValue = displayPropName ? newValue[displayPropName] : newValue;
    }

    this.displayApplyToAllPrompt();
  }

  public confirmApplyToAll() {
    this.resolveApplyToAll();
  }

  public setPromptTimeout() {
    this.isMouseOverPrompt = false;
    setTimeout(() => this.clearApplyToAll(), 5000);
  }

  public clearApplyToAll() {
    if (this.isMouseOverPrompt) {
      return;
    }

    this.showPrompt = false;
    this.fieldTitle = null;
    this.propName = null;
    this.displayValue = null;
  }

  public dismissPrompt() {
    this.showPrompt = false;
    this.fieldTitle = null;
    this.propName = null;
    this.displayValue = null;
  }

  private resolveApplyToAll() {
    this.dataSource.data.forEach((d) => (d[this.propName] = this.applyToAllValue));
    this.appliedToAll.emit(this.dataSource);

    this.dismissPrompt();
  }

  private displayApplyToAllPrompt() {
    this.showPrompt = true;
    this.setPromptTimeout();
  }
}
